import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  Activity,
  ListTodo,
  CreditCard,
  Briefcase,
  FileText,
  Clock,
  ClipboardCheck,
} from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/features/auth';

const settingsItems = [
  {
    title: 'activityTypes',
    description: 'manageActivityTypes',
    icon: Activity,
    path: '/app/settings/activity-types',
    resource: 'activity-type',
  },
  {
    title: 'taskTypes',
    description: 'manageTaskTypes',
    icon: ListTodo,
    path: '/app/settings/task-types',
    resource: 'task-type',
  },
  {
    title: 'paymentMethods',
    description: 'managePaymentMethods',
    icon: CreditCard,
    path: '/app/settings/payment-methods',
    resource: 'payment-method',
  },
  {
    title: 'matterPracticeAreas',
    description: 'manageMatterPracticeAreas',
    icon: Briefcase,
    path: '/app/settings/matter-practice-areas',
    resource: 'matter-practice-area',
  },
  {
    title: 'contractPracticeAreas',
    description: 'manageContractPracticeAreas',
    icon: FileText,
    path: '/app/settings/contract-practice-areas',
    resource: 'contract-practice-area',
  },
  {
    title: 'contractPeriods',
    description: 'manageContractPeriods',
    icon: Clock,
    path: '/app/settings/contract-periods',
    resource: 'contract-period',
  },
  {
    title: 'qa.qaCriteria',
    description: 'qa.manageQaCriteria',
    icon: ClipboardCheck,
    path: '/app/settings/qa-criteria',
    resource: 'qa-criteria',
  },
];

export function SettingsPage() {
  const { t } = useTranslation();
  const { hasAccess } = useAuth();
  const visibleItems = settingsItems.filter((item) => hasAccess(item.resource, 'get'));

  return (
    <div>
      <div className="flex py-4 px-4 justify-between items-center border-b">
        <h1 className="text-xl font-semibold">{t('settings')}</h1>
      </div>

      <div className="p-4">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {visibleItems.map((item) => (
            <Link key={item.path} to={item.path}>
              <Card className="hover:bg-muted/50 transition-colors cursor-pointer h-full">
                <CardHeader className="flex flex-row items-center gap-4">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <item.icon className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <CardTitle className="text-lg">{t(item.title)}</CardTitle>
                    <CardDescription>{t(item.description)}</CardDescription>
                  </div>
                </CardHeader>
                <CardContent />
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
